import { useCallback, useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { useLoader } from '@/providers/loader/LoaderProvider'
import { useSession } from '@/providers/session/SessionProvider'
import BackToLogin from '@/components/Login/BackToLogin'

import toast from '@/utils/toast'
import * as SecurityApi from '@/api/security'

import './EmailSent.scss'

const EmailSent = () => {
  const { setLoading } = useLoader()
  const { formatMessage } = useIntl()
  const { userEmail } = useSession()
  // A second click before the first request settles would send a second e-mail.
  const sending = useRef(false)

  const handleEmailReset = useCallback(async () => {
    if (sending.current) return
    sending.current = true
    try {
      setLoading(true)
      await SecurityApi.resetPassword(userEmail)
      toast.success(formatMessage({ id: 'emailSent.linkResent' }))
    } catch (err) {
      console.log(err)
    } finally {
      sending.current = false
      setLoading(false)
    }
  }, [formatMessage, setLoading, userEmail])

  return (
    <div className="content-wrapper email-sent">
      <div className="envelope" />
      <div className="login-titles">
        <div className="sub-title">
          <FormattedMessage id="emailSent.subTitle" />
        </div>
      </div>
      <div className="login-text-wrapper">
        <p>{userEmail}</p>
      </div>
      <div className="login-text-wrapper">
        <FormattedMessage id="emailSent.checkEmail" />
      </div>
      <div className="login-buttons-wrapper">
        <button className="login-button blue" type="button" onClick={handleEmailReset}>
          <FormattedMessage id="emailSent.resentLink" />
        </button>
        <BackToLogin />
      </div>
    </div>
  )
}

export default EmailSent
